import { useContext } from "react";
import { ContactPanelContext } from "./context";

export default function useContactPanelContext() {
    const context = useContext(ContactPanelContext);
    return context;
}